<template>
  <div>
    <qx-search-box class="searchBox" ref="searchBox" :searchBoxData="searchBoxData" title="筛选" @sub="sub"
                   permpisionsQuery=""></qx-search-box>
    <TableBox ref="tableBox"/>
  </div>
</template>

<script>
import TableBox from './tableBox';
import {getEnumList} from 'api';

export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        alarmTypeOptions: [], // 报警类型
        form: [
          { // 日期
            label: '日期',
            value: 'Date',
            type: 'date',
            placeholder: '请选择日期',
            attr: {
              type: 'daterange',
              time: ['', ''],
            },
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() > Date.now() - 24 * 3600 * 1000;
              },
            },
            default: this.$route.query.startTime ? [this.formatDate(+this.$route.query.startTime), this.formatDate(+this.$route.query.endTime)] : '',
          },
          { // 车牌号
            label: '车牌号',
            value: 'carNo',
            type: 'input',
            default: this.$route.query.carNo ? decodeURI(this.$route.query.carNo) : '',
            placeholder: '请输入车牌号',
          },
          { // 排序方式
            label: '排序方式',
            value: 'orderType',
            type: 'select',
            default: 1,
            placeholder: '请选择排序方式',
            options: [
              {
                label: '结束时间倒序',
                value: 1,
              },
              {
                label: '持续时长倒序',
                value: 2,
              },
            ],
          },
          { // 报警类型
            label: '报警类型',
            value: 'alarmType',
            type: 'select',
            default: '-1',
            placeholder: '请选择报警类型',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.carNo': function (newV, oldV) {
      if (this.$route.path === '/manage/service/oilAndGasConsume/alarm' && newV) {
        this.$nextTick(() => {
          this.$refs.searchBox.setVal('carNo', decodeURI(this.$route.query.carNo));
          this.$refs.searchBox.sub();
        });
      }
    },
    '$route.query.startTime': function (newV, oldV) {
      if (this.$route.path === '/manage/service/oilAndGasConsume/alarm' && newV) {
        this.$nextTick(() => {
          this.$refs.searchBox.setVal('Date', [this.formatDate(newV), this.formatDate(this.$route.query.endTime)]);
          this.$refs.searchBox.sub();
        });
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 处理时间
      if (searchBoxData.Date && searchBoxData.Date.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Date[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Date[1]);
        delete searchBoxData.Date;
      }
      this.$refs.tableBox.saveSearchBoxData({...searchBoxData});
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'TYPES_OF_ALARM',
    });
    this.searchBoxData.alarmTypeOptions = [ // 报警类型
      ...enumsList[0],
    ];
  },
  destroyed () {
    this.$refs.searchBox.setVal('carNo', '');
    this.$refs.searchBox.setVal('Date', '');
  },
};
</script>
